import { Proto } from "./Proto";

import ISODateString = Proto.ISODateString;

/** ANG-6953 special date row (admin + read API). Stored rows use institution-local ISO datetimes. */
export interface SpecialDateRow {
    specialDateId?: number;
    /** US federal occurrence key (e.g. US_JUNETEENTH_2026); admin rows omit. */
    seedKey?: string;
    name: string;
    /** holiday | closure | academic — see SpecialDateCategories. */
    categoryCode: string;
    /** Institution-local start datetime (ISO 8601, no offset). */
    startDate: ISODateString;
    /** Institution-local end datetime (ISO 8601, no offset). */
    endDate: ISODateString;
    /** Per-row opt-in for future calendar indicators (instance pref is separate). */
    showOnCalendar?: boolean;
    /** Soft-deleted rows are excluded from the default list API. */
    isDelete?: boolean;
}

export interface SpecialDatesListResponse {
    dates: SpecialDateRow[];
    featureEnabled?: boolean;
}

export const SpecialDateCategories = {
    HOLIDAY: "holiday",
    CLOSURE: "closure",
    ACADEMIC: "academic",
} as const;
